/* eslint-disable class-methods-use-this */
import _axios, { get, put, _delete } from '@/lin/plugin/axios'

// 我们通过 class 这样的语法糖使模型这个概念更加具象化，其优点：耦合性低、可维护性。
class ProjectModuleInfo {
  // constructor() {}

  // 类中的方法可以代表一个用户行为
  async createProjectModuleInfo(data) {
    return _axios({
      method: 'post',
      url: 'v1/project-module',
      data,
    })
  }

  // 在这里通过 async await 语法糖让代码同步执行
  // 1. await 一定要搭配 async 来使用
  // 2. await 后面跟的是一个 Promise 对象
  async getProjectModuleInfo(id) {
    const res = await get(`v1/project-module/${id}`)
    return res
  }

  async getProjectModuleInfoDetail(id) {
    const res = await get(`v1/project-module/detail/${id}`)
    return res
  }

  async editProjectModuleInfo(id, info) {
    const res = await put(`v1/project-module/${id}`, info)
    return res
  }

  async deleteProjectModuleInfo(id) {
    const res = await _delete(`v1/project-module/${id}`)
    return res
  }

  async getProjectModuleInfoList(params) {
    return _axios({
      method: 'get',
      url: 'v1/project-module/list',
      // params:{keyword:keyword},
      params,
      handleError: true,
    })
  }

  async getProjectModuleInfoPage(params) {
    return _axios({
      method: 'get',
      url: 'v1/project-module/page',
      // params:{keyword:queryForm.keyword.value,status:queryForm.status.value,stage:queryForm.stage.value,type:queryForm.type.value},
      params,
      handleError: true,
    })
  }

  async getProjectModuleTree(params) {
    return _axios({
      method: 'get',
      url: 'v1/project-module/tree/list',
      // params:{keyword:queryForm.keyword.value,status:queryForm.status.value,stage:queryForm.stage.value,type:queryForm.type.value},
      params,
      handleError: true,
    })
  }
}
export default new ProjectModuleInfo()
